import theme from 'theme'

export default function ParamsGrid(props) {
  return (
    <div
      css={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: theme.space[4],
        padding: theme.space[5]
      }}
      {...props}
    />
  )
}
